import { makeStyles } from "@material-ui/core";
import { color } from "../../../assets/const/color";

export const useStyles = makeStyles(() => ({
  staffManagement: {
    "& .MuiInputBase-root": {
      borderRadius: "50px",
      fontFamily: "inter !important",
    },
    "& .MuiButton-root:hover": {
      background: `#9DB2CE !important`,
      color: `${color.white} !important`,
    },
    "& .MuiCheckbox-colorPrimary.Mui-checked": {
      color: `${color.gray} !important`,
      borderRadius: "50px !important",
    },
    "& .MuiCheckbox-root.MuiCheckbox-indeterminate": {
      color: `${color.gray} !important`,
    },
    "& .MuiTableHead-root": {
      "& .MuiTableCell-root": {
        background: "#FEB62C",
        color: `${color.white} !important`,
        fontFamily: "inter",
      },
      "& :first-child": {
        borderRadius: "10px 0px 0px 0px !important",
      },
      "& :last-child": {
        borderRadius: "0px 10px 0px 0px !important",
      },
    },
    "& .MuiTableRow-root .MuiTableCell-root": {
      fontFamily: "inter !important",
    },
    "& .css-1u3bzj6-MuiFormControl-root-MuiTextField-root": {
      width: "200px !important",
    },
    "& ..css-1h6llge-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root": {
      width: "200px !important",
    },
  },
  error: {
    color: "red",
    fontSize: "12px",
  },
  add_new_staff_container: {
    "& .MuiButton-root:hover": {
      background: `${color.lightGreen} !important`,
      color: `${color.white} !important`,
    },
  },
  student_id: {
    color: "#374151",
    fontFamily: "inter !important",
    fontSize: "14px !important",
    fontWeight: "500 !important",
    marginRight: "5px",
  },
  search_btn: {
    minWidth: "200px !important",
    textTransform: "capitalize !important",
    fontFamily: "inter !important",
    fontWeight: "700 !important",
    color: `${color.white} !important`,
    background: `#9DB2CE !important`,
  },
  add_new_staff: {
    minWidth: "200px !important",
    textTransform: "capitalize !important",
    fontFamily: "inter !important",
    fontWeight: "700 !important",
    color: `${color.white} !important`,
    background: `${color.lightGreen} !important`,
  },

  //add edit student styles
  backArrow: {
    cursor: "pointer",
    fontFamily: "inter !important",
    color: `${color.black}`,
    fontSize: "16px",
  },
}));
